// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/ExploreInternetHandlers.js
import { API_ENDPOINTS } from '../api/api';

const fetchPromotions = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.INTERNET_VIEW);
    if (!response.ok) {
      throw new Error(`Failed to fetch promotions data: ${response.statusText}`);
    }
    const data = await response.json();
    return data.promotions || [];
  } catch (error) {
    console.error('Error fetching promotions:', error);
    return [];
  }
};

const insertPromotion = async (data) => {
  try {
    console.log('Inserting promotion with payload:', JSON.stringify(data));
    const response = await fetch(API_ENDPOINTS.INTERNET_INSERT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to insert promotion: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Promotion inserted successfully:', result);
    return result;
  } catch (error) {
    console.error('Error inserting promotion:', error);
    throw error;
  }
};

const updatePromotion = async (data) => {
  try {
    console.log('Updating promotion with payload:', JSON.stringify(data));
    const response = await fetch(API_ENDPOINTS.INTERNET_UPDATE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to update promotion: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Promotion updated successfully:', result);
    return result;
  } catch (error) {
    console.error('Error updating promotion:', error);
    throw error;
  }
};

const deletePromotion = async (id) => {
  try {
    console.log('Deleting promotion with ID:', id);
    const response = await fetch(API_ENDPOINTS.INTERNET_DELETE, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([id]),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to delete promotion: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Promotion deleted successfully:', result);
    return result;
  } catch (error) {
    console.error('Error deleting promotion:', error);
    throw error;
  }
};

// New handlers for InternetHeaderView
const fetchInternetHeaderCategories = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.INTERNET_HEADER_VIEW);
    if (!response.ok) {
      throw new Error(`Failed to fetch header categories: ${response.statusText}`);
    }
    const data = await response.json();
    return data.categories || [];
  } catch (error) {
    console.error('Error fetching header categories:', error);
    return [];
  }
};

const insertInternetHeaderCategory = async (data) => {
  try {
    console.log('Inserting header category with payload:', JSON.stringify(data));
    const response = await fetch(API_ENDPOINTS.INTERNET_HEADER_INSERT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([data]), // API expects an array
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to insert header category: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Header category inserted successfully:', result);
    return result;
  } catch (error) {
    console.error('Error inserting header category:', error);
    throw error;
  }
};

const updateInternetHeaderCategory = async (data) => {
  try {
    console.log('Updating header category with payload:', JSON.stringify(data));
    const response = await fetch(API_ENDPOINTS.INTERNET_HEADER_UPDATE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([data]), // API expects an array
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to update header category: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Header category updated successfully:', result);
    return result;
  } catch (error) {
    console.error('Error updating header category:', error);
    throw error;
  }
};

const deleteInternetHeaderCategory = async (filterKey) => {
  try {
    console.log('Deleting header category with filterKey:', filterKey);
    const response = await fetch(API_ENDPOINTS.INTERNET_HEADER_DELETE, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify([filterKey]), // API expects an array of filterKeys
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to delete header category: ${response.status} - ${errorText}`);
    }
    const result = await response.json();
    console.log('Header category deleted successfully:', result);
    return result;
  } catch (error) {
    console.error('Error deleting header category:', error);
    throw error;
  }
};

export {
  fetchPromotions,
  insertPromotion,
  updatePromotion,
  deletePromotion,
  fetchInternetHeaderCategories,
  insertInternetHeaderCategory,
  updateInternetHeaderCategory,
  deleteInternetHeaderCategory,
};